import SectionLabel from "@/components/base/SectionLabel";
import { dxAdvisoryData } from "@/mocks/dxAdvisoryData";

export default function ScopeSection() {
  return (
    <section id="scope" className="py-20 md:py-28 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="text-center mb-14 md:mb-18 reveal">
          <SectionLabel label={dxAdvisoryData.scope.label} className="mb-3" />
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            {dxAdvisoryData.scope.title}
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8 max-w-5xl mx-auto">
          {/* Included */}
          <div className="reveal rounded-lg bg-background-50 border border-primary-200/60 p-6 md:p-8">
            <div className="flex items-center gap-3 mb-5 md:mb-6 pb-4 border-b border-primary-100/60">
              <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                <i className="ri-check-line text-primary-600 text-xl" />
              </div>
              <h3 className="text-base md:text-lg font-bold text-foreground-900 font-heading">
                {dxAdvisoryData.scope.included.title}
              </h3>
            </div>
            <ul className="space-y-3">
              {dxAdvisoryData.scope.included.items.map((item, i) => (
                <li key={i} className="flex items-start gap-2.5 text-sm md:text-base text-foreground-700">
                  <i className="ri-checkbox-circle-line text-primary-500 mt-0.5 flex-shrink-0" />
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* Excluded */}
          <div className="reveal rounded-lg bg-background-50 border border-background-200/70 p-6 md:p-8">
            <div className="flex items-center gap-3 mb-5 md:mb-6 pb-4 border-b border-background-200/70">
              <div className="w-10 h-10 rounded-full bg-secondary-100 flex items-center justify-center">
                <i className="ri-subtract-line text-secondary-600 text-xl" />
              </div>
              <h3 className="text-base md:text-lg font-bold text-foreground-900 font-heading">
                {dxAdvisoryData.scope.excluded.title}
              </h3>
            </div>
            <ul className="space-y-3">
              {dxAdvisoryData.scope.excluded.items.map((item, i) => (
                <li key={i} className="flex items-start gap-2.5 text-sm md:text-base text-foreground-600">
                  <i className="ri-close-circle-line text-secondary-500 mt-0.5 flex-shrink-0" />
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Important note */}
        <div className="max-w-2xl mx-auto mt-10 md:mt-12 reveal">
          <div className="flex items-start gap-3 bg-primary-50/60 border border-primary-200/60 rounded-lg p-4 md:p-5">
            <i className="ri-information-line text-primary-500 text-lg mt-0.5 flex-shrink-0" />
            <p className="text-sm md:text-base text-foreground-800 leading-relaxed font-medium">
              {dxAdvisoryData.scope.note}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}